import { mutations } from './mutations.js';
import { getters } from './getters.js';

export const quick_searches = () => ({
    mutations,
    getters,
});
